import React from 'react';
import { toast } from 'react-toastify';
import { IconWrapper, SvgIcon } from '../../components/Icon';
import * as ToastMessageUI from './toastMessageUI';
import { MessageContainer } from './toastMessageUI';
import {
  CLOSE_AFTER,
  TOAST_CONTAINER_CLASS_NAME,
  ToastIconDictionary,
} from './utils';
import { MessageType } from './types';
import { getErrorAnalyticsEventFromToast } from '../analytics/events/error/events';
import AnalyticsEventEmitter from '../analytics/AnalyticsEventEmitter';
import { To } from 'react-router-dom';
import { IButtonAnalyticsProps } from '../../components/Button/types';
import { AnalyticsLink } from '../../components/Button';
import { theme } from '../../styles/theme';

interface IProps extends IButtonAnalyticsProps {
  message: string;
  type: MessageType;
  redirectPath?: To;
  buttonLabel?: string;
}

const toastMessage = ({
  message,
  type,
  buttonLabel = 'View',
  redirectPath = '',
  trackContext,
  trackAction,
}: IProps) => {
  const { containerColor, iconName } = ToastIconDictionary[type];
  const analyticsEvent = getErrorAnalyticsEventFromToast(type, message);

  return toast(
    (props) => (
      <ToastMessageUI.Container>
        {analyticsEvent && <AnalyticsEventEmitter event={analyticsEvent} />}
        <MessageContainer>
          <ToastMessageUI.StyledIconWrapper
            size={32}
            style={{ backgroundColor: containerColor }}
          >
            <SvgIcon
              name={iconName}
              width={24}
              height={24}
              customFill={theme.colors.white}
            />
          </ToastMessageUI.StyledIconWrapper>
          <ToastMessageUI.ToastMessage>{message}</ToastMessageUI.ToastMessage>
          <IconWrapper size={32}>
            <SvgIcon
              name="icon-x"
              width={20}
              height={20}
              customFill={theme.colors.white}
              onClick={() => props.closeToast?.()}
              isHoverable={true}
            />
          </IconWrapper>
        </MessageContainer>
        {redirectPath && (
          <ToastMessageUI.StyledButton
            forwardedAs={AnalyticsLink}
            to={redirectPath}
            onClick={() => props.closeToast?.()}
            trackContext={trackContext}
            trackAction={trackAction}
          >
            {buttonLabel}
          </ToastMessageUI.StyledButton>
        )}
      </ToastMessageUI.Container>
    ),
    {
      className: TOAST_CONTAINER_CLASS_NAME,
      autoClose: CLOSE_AFTER,
      pauseOnHover: true,
      position: 'bottom-left',
      closeOnClick: false,
      draggable: false,
      closeButton: false,
    },
  );
};

export default toastMessage;
